import { useState } from 'react'

import Moment from 'react-moment'

import { makeStyles } from '@material-ui/core/styles'
import { Typography, Paper, Divider } from '@material-ui/core'
import { CreateOutlined, PeopleOutlined, NavigateNextOutlined, BusinessOutlined, SubjectOutlined, FormatListBulletedOutlined, DoneOutlineOutlined } from '@material-ui/icons'

import logo from '../../assets/logo.png'
import './styles.css'

const useStyles = makeStyles({
    titleStyle: {
        marginTop:'50px'
    },
    iconStyle: {
        fontSize: '14px'
    },
    dividerStyle: {
        marginTop: '8px',
        marginBottom: '8px'
    },
    typStyle: {
        marginBottom: '16px'
    },
    tarefaStyle: {
        marginBottom: '36px'
    },
    innerTypStyle: {
        color: '#757575',
        fontSize: '12px',
        textTransform: 'uppercase',
        marginRight: '4px'
    },
    smallTitleStyle: {
        color: '#002884'
    }
})

function AtaVersao() {
    const classes = useStyles()

    const [ata] = useState([{
        d: {
            participantesClientes: [],
            participantesFN: [],
            proximosPassos: []
        }
    }])
    const [ataOwner] = useState({})

    return (
        <Paper elevation={6}>
            <div className="leitura-versao-container">

                <center><img src={logo} alt="Xerlock - Analytics & Data Mining" style={{ width: '210px', height: '100px', marginTop: '60px' }} /></center>

                <Typography 
                    className={classes.titleStyle} 
                    align="left" 
                    variant="h6" 
                >
                ATA DE REUNIÃO
                </Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Autor <CreateOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ataOwner.nome}</Typography>

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Cliente <BusinessOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.length > 0 && ata[0].d.cliente}</Typography>

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Assunto <SubjectOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.length > 0 && ata[0].d.assunto}</Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Participantes <PeopleOutlined className={classes.iconStyle} />
                </Typography>

                <br />
                <Typography component={'span'} className={classes.innerTypStyle}>FN:</Typography>
                {ata[0].d.participantesFN.map(participanteFN => (
                    <Typography display="block">{participanteFN.emailFN}</Typography>
                ))}
                
                <br />
                <Typography component={'span'} className={classes.innerTypStyle}>Clientes:</Typography>
                {ata[0].d.participantesClientes.map(participanteCliente => (
                    <Typography display="block">{participanteCliente.emailCliente}</Typography>
                ))}
                
                <Divider className={classes.dividerStyle} variant="fullWidth" />        

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Pontos abordados <FormatListBulletedOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.length > 0 && ata[0].d.pontosAbordados}</Typography>

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Decisões tomadas <DoneOutlineOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.length > 0 && ata[0].d.decisoesTomadas}</Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Próximos passos <NavigateNextOutlined className={classes.iconStyle}/>
                </Typography>

                <br/>
                {ata[0].d.proximosPassos.map(proximoPasso => (
                    <Typography display="block">
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Responsável: </Typography>{proximoPasso.responsavel}
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Tarefa: </Typography>{proximoPasso.tarefa}
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Prazo: </Typography><Moment add={{ days: 1 }} format="DD/MM/YYYY">{proximoPasso.prazo}</Moment>                        
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Código Redmine: </Typography>#{proximoPasso.codigoRedmine}
                        <br/>
                        <br/>
                    </Typography>
                ))}

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography color="textSecondary" variant="caption">Ata de reunião modificada em <Moment format="DD/MM/YYYY">{ata.length > 0 && ata[0].t}</Moment> às <Moment format="HH">{ata.length > 0 && ata[0].t}</Moment>h<Moment format="mm">{ata.length > 0 && ata[0].t}</Moment></Typography>
                
            </div>
        </Paper>
    )
}

export default AtaVersao
